export default function PersonalNote() {
    return (
        <section className="py-16 md:py-20">
            <div className="max-w-3xl">
                <h2 className="text-lg font-medium text-warm-gray-500 mb-6 tracking-wide">
                    A Quiet Personal Note
                </h2>

                <p className="text-body-lg text-warm-gray-600 max-w-prose">
                    Outside client work, I'm drawn to illustration, tactile processes, and noticing everyday visual moments — packaging on shelves, handwritten notes, old signboards, unfinished ideas.
                </p>

                <p className="text-body-lg text-warm-gray-500 mt-6 italic">
                    These often find their way back into my work.
                </p>
            </div>
        </section>
    );
}
